module.exports = __webpack_public_path__ + "img/clock-refresh.76fa732a.svg";